@if (resource && !(onLoading$ | async)) {
<mat-card class="profile-card pb-20 detail-base" style="width: 100%;">
    <mat-card-header>
        <mat-card-title>
            <div class="g-just-flex gap-8" style="flex-wrap: wrap;">
                <div class="round-icon-wrapper contrast">
                    <mat-icon>
                        medication
                    </mat-icon>
                </div>
                <span> {{resource.resourceType}}</span>
            </div>
        </mat-card-title>

    </mat-card-header>
    <mat-card-content>
        <div class="my-10">
            <mat-divider>

            </mat-divider>
            <div class="my-20"></div>


            <div class="other-details">
                @for(key of fieldKeys(resource); track $index;){
                        
                <div class="field-group" style="width: 100%; overflow-x: auto;">

                    @if(keyTypes[resource.resourceType] && keyTypes[resource.resourceType]?.[key] == 'Reference'
                    && resource[key]
                    ){
                                          <!-- {{resource[key] | json}} -->
                        <div [appReferenceDisplay]="resource[key]?.reference"
                        [InstantfetchAndRepace]="true" [keepReference]="true" class="field-value"
                        ></div>
                    }@else{
                   
                    <div class="field-value" [innerHTML]="renderOtherFields(resource, key)">

                    </div>}
                    <div class="field-title subtitle-text-color" style="font-weight: bold;">
                        {{key | titlecase}}
                    </div>
                </div>
                }


            </div>

        </div>
    </mat-card-content>
</mat-card>

}@else {
<mat-progress-spinner></mat-progress-spinner>
}